import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseMasterCreateRequestDTO, PurchaseMasterDTO, PurchaseMasterUpdateRequestDTO, PurchaseMasterDeleteRequestDTO, PurchaseMasterReadByIdRequestDTO, PurchaseMasterReadByTenantIdRequestDTO, PurchaseMasterReadByOrderIdRequestDTO, PurchaseMasterList, PurchaseMasterSearchByInvoiceNo, PurchaseMasterReadBySupplierCompanyIdRequestDTO } from './purchase.interface';
import {
  PurchaseMaster_Create, PurchaseMaster_Delete, PurchaseMaster_ReadAll, PurchaseMaster_ReadByTenantId, PurchaseMaster_ReadById,
  PurchaseMaster_ReadByOrderId, PurchaseMaster_ReadBySupplierCompanyId, PurchaseMaster_SearchByInvoiceNo, PurchaseMaster_Update
} from 'src/app/GlobalVariables';
import { GenericListDataReadAllPaginatedRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';


import {
  PurchaseInvoiceOtherCharges_Create, PurchaseInvoiceOtherCharges_Update, PurchaseInvoiceOtherCharges_Delete, PurchaseInvoiceOtherCharges_ReadAll, PurchaseInvoiceOtherCharges_ReadById,
  PurchaseInvoiceOtherCharges_ReadByInvoiceId, PurchaseInvoiceOtherCharges_ReadByItemId, PurchaseInvoiceOtherCharges_ReadByInvoiceIdForImport
} from 'src/app/GlobalVariables';


import {
  PurchaseInvoiceOtherChargesCreateRequestDTO, PurchaseInvoiceOtherChargesDTO,
  PurchaseInvoiceOtherChargesReadByInvoiceIdRequestDTO, PurchaseInvoiceOtherChargesUpdateRequestDTO,
  PurchaseInvoiceOtherChargesList,
  PurchaseInvoiceOtherChargesDeleteRequestDTO,
  PurchaseInvoiceOtherChargesReadByIdRequestDTO
} from './purchaseInvoiceOtherCharges.interface'


@Injectable({
  providedIn: 'root'
})
export class PurchaseService {
  getAllPaginatedData(readAllDTO: GenericListDataReadAllPaginatedRequestDTO) {
    throw new Error('Method not implemented.');
  }


  constructor() { }

  http = inject(HttpClient);

  PurchaseMaster_Create(data: PurchaseMasterCreateRequestDTO): Observable<PurchaseMasterDTO> {
    return this.http.post<PurchaseMasterDTO>(PurchaseMaster_Create, data);

  }

  PurchaseMaster_Update(data: PurchaseMasterUpdateRequestDTO): Observable<PurchaseMasterDTO> {
    return this.http.post<PurchaseMasterDTO>(PurchaseMaster_Update, data);
  }

  PurchaseMaster_Delete(data: PurchaseMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseMaster_Delete, data);
  }

  PurchaseMaster_ReadAll(): Observable<PurchaseMasterList> {
    return this.http.get<PurchaseMasterList>(PurchaseMaster_ReadAll);
  }

  PurchaseMaster_ReadById(data: PurchaseMasterReadByIdRequestDTO): Observable<PurchaseMasterDTO> {
    return this.http.post<PurchaseMasterDTO>(PurchaseMaster_ReadById, data);
  }

  PurchaseMaster_ReadByTenantId(data: PurchaseMasterReadByTenantIdRequestDTO): Observable<PurchaseMasterDTO> {
    return this.http.post<PurchaseMasterDTO>(PurchaseMaster_ReadByTenantId, data);
  }

  PurchaseMaster_ReadByOrderId(data: PurchaseMasterReadByOrderIdRequestDTO): Observable<PurchaseMasterDTO> {
    return this.http.post<PurchaseMasterDTO>(PurchaseMaster_ReadByOrderId, data);
  }

  PurchaseMaster_SearchByInvoiceNo(data: PurchaseMasterSearchByInvoiceNo): Observable<PurchaseMasterList> {
    return this.http.post<PurchaseMasterList>(PurchaseMaster_SearchByInvoiceNo, data);
  }

  PurchaseMaster_ReadBySupplierCompanyId(data: PurchaseMasterReadBySupplierCompanyIdRequestDTO): Observable<PurchaseMasterList> {
    return this.http.post<PurchaseMasterList>(PurchaseMaster_ReadBySupplierCompanyId, data);
  }



  //PurchaseOther charges
  PurchaseInvoiceOtherCharges_Create(data: PurchaseInvoiceOtherChargesCreateRequestDTO): Observable<PurchaseInvoiceOtherChargesDTO> {
    // return this.http.post<PurchaseInvoiceOtherChargesDTO>("https://dev.ms.vnccy.com/ERP/Billing/PurchaseInvoiceOtherCharges/Create", data)
    return this.http.post<PurchaseInvoiceOtherChargesDTO>(PurchaseInvoiceOtherCharges_Create, data)
  }
  PurchaseInvoiceOtherCharges_Update(data: PurchaseInvoiceOtherChargesUpdateRequestDTO): Observable<PurchaseInvoiceOtherChargesDTO> {
    return this.http.post<PurchaseInvoiceOtherChargesDTO>(PurchaseInvoiceOtherCharges_Update, data)
  }

  PurchaseInvoiceOtherCharges_Delete(data: PurchaseInvoiceOtherChargesDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseInvoiceOtherCharges_Delete, data)
  }

  PurchaseInvoiceOtherCharges_ReadById(data:PurchaseInvoiceOtherChargesReadByIdRequestDTO):Observable<PurchaseInvoiceOtherChargesDTO>{
      return this.http.post<PurchaseInvoiceOtherChargesDTO>(PurchaseInvoiceOtherCharges_ReadById ,data)
  }

  PurchaseInvoiceOtherCharges_ReadByInvoiceId(data: PurchaseInvoiceOtherChargesReadByInvoiceIdRequestDTO): Observable<PurchaseInvoiceOtherChargesList> {
    return this.http.post<PurchaseInvoiceOtherChargesList>(PurchaseInvoiceOtherCharges_ReadByInvoiceId, data)
  }
  PurchaseInvoiceOtherCharges_ReadAll(): Observable<PurchaseInvoiceOtherChargesList> {
    return this.http.get<PurchaseInvoiceOtherChargesList>(PurchaseInvoiceOtherCharges_ReadAll);
  }


}
